import { InvoiceTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1970. 請求タスク請求金額編集
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/update_billing_amount
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  billing_amount: number;
  billing_amount_including_tax?: number;
};

const updateBillingAmount = (props: Props): Promise<InvoiceTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/update_billing_amount`,
    props
  );
};

export const useUpdateBillingAmount = () => {
  return useMutation({
    mutationFn: updateBillingAmount
  });
};